export default "__VITE_ASSET__CQZ8MFx9__"